import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import RouteConfig from './Route';
import './App.css';
import Navigation from './Components/SideNav';
import themes from './themes';
import Footer from './Components/Footer';


const theme = createTheme(themes.hyperDart);
console.log("Environment:", process.env.REACT_APP_STAGE);




function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleCategory = (item) => {
    navigate(`/${item.categoryName.replaceAll(" ", "")}`, {
      state: { selectedCategory: item.categoryName },
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        {
          location.pathname !== '/logout' ? <Navigation
            handleCategory={handleCategory} /> : null
        }
        <div
          className={location.pathname !== '/logout' ? 'main-content' : ''}
          style={{
            marginTop:
              window.innerWidth > 600
                ? "76px"
                : location.pathname.includes('/package/') || location.pathname.includes('/store-listing/')
                  ? "96px"
                  : "120px"
          }}
        >

          <RouteConfig
          />

        </div>

        <div className='footer'>
          <Footer />

        </div>
      </div>
    </ThemeProvider>
  );
}


export default App;
